<template>
  <div class="badge">
    {{number}}
  </div>
</template>

<script>
export default {
  name: 'adx-badge',
  props: {
    number: {
      required: false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>